import * as Yup from 'yup'

export const InsuranceBeneficiarySchema = Yup.object().shape({
  firstName: Yup.string().required('First name type is required'),
  lastName: Yup.string().required('Make is required'),
  relation: Yup.string().required('Relation is required'),
})
